import React, {useState} from 'react';
import {ReactComponent as CoinsIco} from "../../../images/icons/coins.svg";
import {Modal} from "react-bootstrap";
import IframeWidget from "../../utils/IframeWidget";
import RoundedIcon from "../Common/RoundedIcon";
import {useTranslation} from "react-i18next";
import ErrorFormHelper from "../../utils/ErrorFormHelper";
import ErrorFormView from "../Common/ErrorFormView";

interface Props {
	onHide: () => void;
	handleSave: (tipAmount?: number) => void;
	tipAmount?: number;
	errors: any[];
	currency: string;
}


const CartTipModal = ({onHide, handleSave, tipAmount, errors, currency}: Props) => {
	const {t} = useTranslation();
	const [amount, setAmount] = useState<number | undefined>(tipAmount);

	const handleChangeAmount = (event: React.FocusEvent<HTMLInputElement> |  React.ChangeEvent<HTMLInputElement>) => {
		if(!event.target.value){
			setAmount(undefined)
			return;
		}
		const value = Number(event.target.value);

		if (value < 0) {
			setAmount(Math.abs(value));
			return;
		}

		if (isNaN(value)) {
			setAmount(0)
		}
		else {
			setAmount(value)
		}
	}

	const onSaveClick = () => {
		handleSave(amount);
		onHide();
	}

	return (
		<Modal dialogClassName="modal-full" className='small-modal modal-new' show onHide={() => IframeWidget.onHide(onHide)}>
			<div>
				<Modal.Header>
					<button onClick={() => IframeWidget.onHide(onHide)} className="btn-close" data-bs-dismiss="modal"
							aria-label="Close"/>
				</Modal.Header>
			</div>
			<Modal.Body>
				<div className='d-flex flex-column align-items-center'>
					<div className="w-100 d-flex align-items-center justify-content-center mb-3">
						<RoundedIcon icon={<CoinsIco/>}/>
					</div>
					<h5 className="mb-2">
						{t("modules.cart.field.tip.title")}
					</h5>
					<div className="my-3 w-100">
						<div className="form-group tip-input-wrapper">
							<div className="input-group">
								<input onBlur={handleChangeAmount} value={amount}
									   onChange={handleChangeAmount}
									   type="number"
									   step="0.01"
									   className={"form-control" + ErrorFormHelper(errors, "amount")}
									   id="tip"
									   min="0"
									   placeholder={t("modules.cart.field.tip.placeholder")}/>
								<span className="input-group-text">{currency}</span>
							</div>
							<ErrorFormView errors={errors} field="amount"/>
						</div>
						</div>
						<div className="d-flex w-100 gap-3">
						<button className="btn btn-lg btn-default flex-grow-2" onClick={onHide}>
							{t("common.action.cancel")}
						</button>
						<button className={"btn btn-lg btn-primary flex-grow-1"} onClick={onSaveClick}>
							{t("common.action.save")}
						</button>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default CartTipModal;